export class ProbeFailedResponseError {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "code",
            "baseName": "code",
            "type": "string",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        },
        {
            "name": "hint",
            "baseName": "hint",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ProbeFailedResponseError.attributeTypeMap;
    }
    constructor() {
    }
}
